<template>
    <v-select v-model="status" 
        :items="itens"
        :rules="rules || []"
        item-text="descricao"
        label="Status"
        return-object>
        <template slot="selection" slot-scope="data">
            <v-icon class="mt-2 mb-2" :color="permissaoAnalisaSolicitacao ? data.item[0].corIcone : data.item[0].corIconeCliente">
                {{ permissaoAnalisaSolicitacao ? data.item[0].icone : data.item[0].iconeCliente }}
            </v-icon>
            <span class="ml-3 subheading" :style="`color: ${permissaoAnalisaSolicitacao ? data.item[0].corIcone : data.item[0].corIconeCliente}`">
                {{ permissoesComputed.getPermissao(4) ? data.item[0].descricao : data.item[0].statuscliente }}
            </span>
        </template>
        <template slot="item" slot-scope="data">
            <v-list-tile-avatar>
                <v-icon :color="permissaoAnalisaSolicitacao ? data.item[0].corIcone : data.item[0].corIconeCliente">{{ permissaoAnalisaSolicitacao ? data.item[0].icone : data.item[0].iconeCliente}}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title v-if="permissoesComputed.getPermissao(4)" :style="`color: ${permissaoAnalisaSolicitacao ? data.item[0].corIcone : data.item[0].corIconeCliente}`" v-html="data.item[0].descricao"></v-list-tile-title>
                <v-list-tile-title v-else :style="`color: ${permissaoAnalisaSolicitacao ? data.item[0].corIcone : data.item[0].corIconeCliente}`" v-html="data.item[0].statuscliente"></v-list-tile-title>
            </v-list-tile-content>
        </template>
    </v-select>
</template>

<script>
import axios from 'axios'
import cipher from '@/helpers/cipher'
import permissoes from '@/helpers/permissoes.js'

export default {
    name: 'v-select-status',
    props: {
        value: {
            type: [Array, Object],
            default: function () { return []; }
        },
        rules: {
            type: Array,
            default: function () { return []; }
        },
        itens: {
            type: Array,
            default: function () { return []; }
        },
        status: {
            type: Array,
            default: function () { return []; }
        }
    },
    computed: {
        permissoesComputed: function() {
          return permissoes;
        },
        permissaoAnalisaSolicitacao: function() {
          return permissoes.verificaPermissao(permissoes.SolicitacaoConsulta.ANALISA_SOLICITACAO)
        }
    },
    watch: {
        status: function (val) {
            this.$emit('input', val);
        }
    },
    methods: {
      //
    }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/VSelectStatus.vue